import { CopyOutlined } from '@ant-design/icons';
import { Button, Input, message, Modal, Space } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  ThreadsIcon,
  ThreadsShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';
import './style.less';

const PdfShareComponent = ({
  pdfShareurl,
  modalOpen,
  onClose,
}: {
  pdfShareurl: string;
  modalOpen: boolean;
  onClose: () => void;
}) => {
  const shareUrl = pdfShareurl;

  const handleCancel = () => {
    onClose();
  };

  const handleCopy = () => {
    message.success('Copied to clipboard');
    onClose();
  };

  return (
    <>
      <Modal
        className="pdf-modal"
        title="Share Report"
        open={modalOpen}
        footer={null}
        onCancel={handleCancel}
      >
        <div className="share-icons-div">
          <FacebookShareButton url={shareUrl}>
            <FacebookIcon size={45} round={true} />
          </FacebookShareButton>

          <WhatsappShareButton url={shareUrl}>
            <WhatsappIcon size={45} round={true} />
          </WhatsappShareButton>

          <TelegramShareButton url={shareUrl}>
            <TelegramIcon size={45} round={true} />
          </TelegramShareButton>

          <ThreadsShareButton url={shareUrl}>
            <ThreadsIcon size={45} round={true} />
          </ThreadsShareButton>

          <TwitterShareButton url={shareUrl}>
            <TwitterIcon size={45} round={true} />
          </TwitterShareButton>
        </div>
        <div className="clipboard-div">
          <Space.Compact className="clipboard">
            <Input value={shareUrl} readOnly />
            <CopyToClipboard text={shareUrl} onCopy={handleCopy}>
              <Button type="primary" icon={<CopyOutlined />}>
                Copy Url
              </Button>
            </CopyToClipboard>
          </Space.Compact>
        </div>
      </Modal>
    </>
  );
};

export default PdfShareComponent;
